module.exports = __webpack_public_path__ + "img/login.e56b8419.png";